var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _vm.enabledExcel
              ? _c(
                  "button",
                  {
                    staticClass: "btn-success",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.exportaExcel()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-file-excel-o" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Exportar")])
                  ]
                )
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("k-table", {
        ref: "listaProyectos",
        attrs: {
          filterStatus: _vm.filterStatus,
          editButton: false,
          deleteButton: false,
          createButton: false,
          fechas: true,
          path: _vm.url + "/proyectos",
          columns: [
            {
              display: "Código",
              value: "codigo"
            },
            {
              display: "Nombre",
              value: "nombre"
            },
            {
              display: "Descripción",
              value: "descripcion"
            },
            {
              display: "Fecha inicio",
              value: "fecha_inicio"
            },
            {
              display: "Estado",
              value: "nombre_estado"
            },
            {
              display: "Fecha de creación",
              value: "created_at"
            },
            {
              display: "Fecha de modificación",
              value: "updated_at"
            }
          ]
        },
        on: { seleccionar: _vm.seleccionar }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Lista de Proyectos")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93cf1fea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93cf1fea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/procesos/ListaProyectos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-93cf1fea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/procesos/ListaProyectos.vue
// module chunks = 0